import {useIntl} from 'react-intl'
import useAddressFields from './useAddressFields'
import {useBrand} from '../../contexts/brand-context'

const WEB_FLOATING = 'webFloatingField'

const withVariant = (field, overrides = {}) => ({
    ...field,
    variant: WEB_FLOATING,
    ...overrides
})

export default function useAddressBookFields(formArgs) {
    const fields = useAddressFields(formArgs)
    const {formatMessage} = useIntl()
    const {isGarage} = useBrand()

    return {
        ...fields,
        addressTitle: withVariant(fields.addressTitle, {
            rules: {
                ...fields.addressTitle.rules,
                required: isGarage
                    ? formatMessage({
                          defaultMessage: 'Enter your address label',
                          id: 'address_book_fields.error.custom_address_label_required.garage'
                      })
                    : formatMessage({
                          defaultMessage: 'Enter your address label',
                          id: 'address_book_fields.error.custom_address_label_required.dynamite'
                      })
            }
        }),
        firstName: withVariant(fields.firstName, {
            rules: {
                ...fields.firstName.rules,
                required: isGarage
                    ? formatMessage({
                          defaultMessage: 'Enter your first name',
                          id: 'address_book_fields.error.custom_first_name_required.garage'
                      })
                    : formatMessage({
                          defaultMessage: 'Enter your first name',
                          id: 'address_book_fields.error.custom_first_name_required.dynamite'
                      })
            }
        }),
        lastName: withVariant(fields.lastName, {
            rules: {
                ...fields.lastName.rules,
                required: isGarage
                    ? formatMessage({
                          defaultMessage: 'Enter your last name',
                          id: 'address_book_fields.error.custom_last_name_required.garage'
                      })
                    : formatMessage({
                          defaultMessage: 'Enter your last name',
                          id: 'address_book_fields.error.custom_last_name_required.dynamite'
                      })
            }
        }),
        address1: withVariant(fields.address1),
        apartment: withVariant(fields.apartment),
        city: withVariant(fields.city, {
            rules: {
                ...fields.city.rules,
                required: isGarage
                    ? formatMessage({
                          defaultMessage: 'Enter a town or city',
                          id: 'address_book_fields.error.custom_city_required.garage'
                      })
                    : formatMessage({
                          defaultMessage: 'Enter a town or city',
                          id: 'address_book_fields.error.custom_city_required.dynamite'
                      }),
                minLength: {
                    value: 2,
                    message: formatMessage({
                        defaultMessage: 'Between 2 to 50 characters are required.',
                        id: 'address_book_fields.error.between_2_50'
                    })
                }
            }
        }),
        countryCode: withVariant(fields.countryCode),
        stateCode: withVariant(fields.stateCode),
        postalCode: withVariant(fields.postalCode, {
            rules: {
                ...fields.postalCode.rules,
                required: formatMessage({
                    defaultMessage: 'Enter a valid zip / postal code',
                    id: 'address_book_fields.error.custom_postcode_required'
                })
            }
        }),
        phone: withVariant(fields.phone, {
            rules: {
                ...fields.phone.rules,
                required: isGarage
                    ? formatMessage({
                          defaultMessage: 'Enter your telephone number',
                          id: 'address_book_fields.error.custom_phone_required.garage'
                      })
                    : formatMessage({
                          defaultMessage: 'Enter your telephone number',
                          id: 'address_book_fields.error.custom_phone_required.dynamite'
                      })
            }
        })
    }
}
